import ButtonModule from './button.module'

export default ButtonModule
